// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import Close from "@synd/XDL/Icons/Close";
import { buttonTransparent } from "@synd/XDL/PreStyle/button";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import color from "@synd/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            size: fontConfig.xSmall.size,
            weight: fontConfig.weight.bold,
            color: "text",
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: ${fontConfig.xSmall.lineHeight};
            `,
        },
        color: "common.ui1",
        iconProps: {
            src: Close,
            color: "common.ui7",
            width: 7,
            height: 10,
        },
        css: css`
            align-items: center;
            min-height: 25px;
            border-radius: 8px;
            align-items: flex-start;
            word-break: break-all;
            gap: 6px;
            padding: 4px 8px;
            margin: 0 8px 8px 0;
            border: 1px solid ${color("common.ui7")};
            button {
                margin: 0;
                flex-basis: unset;
                height: 17px;
                display: flex;
                align-items: center;
                ${buttonTransparent}
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui11")};
                    }
                }
            }
        `,
    },
} as xBaseTheme["tag"];
